import React from 'react';
import i18n from 'i18next';
import { Button } from 'semantic-ui-react';
import cs from 'classnames';
import Currency from '../../Currency';
import styles from '../PaymentsScreen.module.scss';

export const MakePayment = (row, handleActBtnClick) => (row.type !== 'appa' ? (
  <Button
    type="button"
    onClick={() => handleActBtnClick(row)}
    className={cs(styles.actionsBtn, 'orange_button')}
  />
) : (
  <></>
));

export const DownloadPdf = (row) => (row.type === 'recurring-payment' ? (
  <Button
    target="_blank"
    href={`/api/check/${row.id}?c=${row.contractId}`}
    download={`payment-check-${row.id}`}
    icon="download"
    className={cs(styles.downloadCheckButton, 'blue_button')}
  />
) : (
  <></>
));

export const ContractId = (
  row,
  cell,
  prps,
  getSortArrow,
  handleActBtnClick,
) => {
  const { property, title } = cell;
  const { handleSort, direction, column } = prps;

  return (
    <div className={styles.firstCell}>
      <div onClick={() => handleSort(property)} role="presentation">
        <p className={styles.expandTitle}>
          {i18n.t(title)}
          {getSortArrow(direction, column, property)}
        </p>
        <p className={styles.expandProperty}>{row[property]}</p>
      </div>

      <div className={styles.buttonsSection}>
        <div className={styles.mobileBtn}>
          {MakePayment(row, handleActBtnClick)}
        </div>
        <div className={styles.mobileBtn}>{DownloadPdf(row)}</div>
      </div>
    </div>
  );
};

export const Amount = (row, cell, prps, getSortArrow) => {
  const { property, title } = cell;
  const { handleSort, direction, column } = prps;
  return (
    <div onClick={() => handleSort(property)} role="presentation">
      <p className={styles.expandTitle}>
        {i18n.t(title)}
        {getSortArrow(direction, column, property)}
      </p>
      <p className={styles.expandProperty}>
        <Currency value={row[property]} withCurrencyLabel />
      </p>
    </div>
  );
};

export const PayMethod = (row, cell, prps, getSortArrow) => {
  const { property, title } = cell;
  const { handleSort, direction, column } = prps;
  const paymentMethods = {
    1: 'card',
    2: 'idram',
  };
  const val = paymentMethods[row[property]];

  return (
    <div onClick={() => handleSort(property)} role="presentation">
      <p className={styles.expandTitle}>
        {i18n.t(title)}
        {getSortArrow(direction, column, property)}
      </p>
      <p className={styles.expandProperty}>
        {val && i18n.t(`paymentTbl.payMethod.${val}`)}
      </p>
    </div>
  );
};
